import React, { useState } from "react";
import { Button, Form, Toast, ToastContainer } from "react-bootstrap";
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../constants";
import { apiFetch } from "../../utils/apiFetch";

const ChangePassword = ({ mode = "self", targetData = null, onComplete, onApiError }) => {
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  const navigate = useNavigate();

  const validatePassword = (password) => {
    // Şifrə 8-50 simvol, ən azı 1 böyük, 1 kiçik, 1 rəqəm və 1 xüsusi simvol
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,50}$/;
    return pattern.test(password);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validatePassword(newPassword)) {
      setError("Şifrə 8-50 simvol, ən azı 1 böyük, 1 kiçik, 1 rəqəm və 1 xüsusi simvol olmalıdır!");
      return;
    }
    setError("");
    setShowModal(true);
  };

  const confirmChangePassword = async () => {
    setShowModal(false);
    
    const isStudent = mode === "student";
    
    // Əgər tələbədirsə fərqli URL, özüdürsə BASE_URL daxili URL
    const url = isStudent 
      ? BASE_URL+"/students/set-default-password" 
      : `${BASE_URL}/users/change-password`;
    
    // 405 errorunun qarşısını almaq üçün: Tələbə endpointi çox vaxt PUT və ya POST olur.
    // Əgər POST ilə 405 aldınsa, aşağıdakı metodu "PUT" edirik.
    const method = isStudent ? "PUT" : "PUT"; 
    
    const payload = isStudent 
      ? { username: targetData?.username, password: newPassword }
      : { 
          newPassword: newPassword, 
          newPasswordRepeat: newPassword, 
          oldPassword: "" 
        };

    try {
      const res = await apiFetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        if (onApiError) {
          onApiError(data);
        } else {
          setToastVariant("danger");
          setToastMessage(data?.message ?? 'Xəta baş verdi.');
          setShowToast(true);
        }
        return;
      }

      setToastVariant("success");
      setToastMessage(isStudent ? "Tələbə şifrəsi yeniləndi!" : "Şifrəniz uğurla dəyişdirildi!");
      setShowToast(true);

      if (isStudent) {
        setTimeout(() => {
          if (onComplete) onComplete();
          setNewPassword("");
        }, 1500);
      } else {
        setTimeout(() => {
          localStorage.clear();
          navigate("/");
        }, 2000);
      }
    } catch (err) {
      const msg = 'Şifrə dəyişdirilərkən xəta baş verdi.';
      if (onApiError) {
        onApiError({ message: msg });
      } else {
        setToastVariant("danger");
        setToastMessage(msg);
        setShowToast(true);
      }
    }
  };

  return (
    <div className="w-100">
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label className="fw-medium small text-muted">
            {mode === "student" 
              ? `${targetData?.name} ${targetData?.surname} üçün yeni şifrə` 
              : "Öz yeni şifrəniz"}
          </Form.Label>
          <div style={{ position: "relative" }}>
            <Form.Control
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="noShadowInput"
              placeholder="********"
              required
              autoComplete="new-password"
              style={{ paddingRight: 36 }}
            />
            <i
              className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
              onClick={() => setShowPassword(p => !p)}
              style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#9ca3af", fontSize: 15 }}
            />
          </div>
          {error && <div className="text-danger mt-1" style={{fontSize: '11px'}}>{error}</div>}
        </Form.Group>
        <Button variant="success" className="w-100 py-2 fw-semibold" type="submit">
          {mode === "student" ? "Şifrəni Sıfırla" : "Yadda saxla"}
        </Button>
      </Form>

      <ConfirmModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={confirmChangePassword}
        title="Təsdiq"
        message={mode === "student" ? "Tələbənin şifrəsini dəyişmək istədiyinizə əminsiniz?" : "Şifrənizi dəyişmək istədiyinizə əminsiniz?"}
        confirmText="Təsdiqlə"
        variant="primary"
      />

      {/* Toast Bildirişləri */}
      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 99999 }}>
        <Toast show={showToast} autohide delay={2000} bg={toastVariant} onClose={() => setShowToast(false)}>
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Sistem Mesajı</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default ChangePassword;